import { HttpParams } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { LazyLoadEvent } from 'primeng/primeng';
import { catchError, map, tap } from 'rxjs/operators';
import { BaseCrudService } from '../../shared/_utils/services/base-crud-service';
import { FormatUtils } from '../../shared/_utils/services/formatUtils';
import { QueryOperator } from '../../shared/_utils/services/query-operator.enum';
import { Bank } from '../entities/bank';
import { ClockEntry } from '../entities/clock-entry';
import { Observable } from 'rxjs/Observable';
import { ResponsePageable } from 'app/shared/_utils/services/responsePageable';
import { ClockEntryMessage } from '../model/clock-entry-message';
import { BiometricTimeClockImport } from '../model/biometric-time-clock-import';

@Injectable()
export class ClockEntryService extends BaseCrudService<ClockEntry> {

    public uri = '/api/clockEntry/';

    constructor(injector: Injector) {
        super(injector);
       //console.log('Instance ClockEntryService');
    }

    buildSentence(entity?: ClockEntry, event?: LazyLoadEvent): HttpParams {
        // if (entity) {
        //     let query = entity.code ? 'code'
        //         + QueryOperator.Contain + entity.code
        //         + QueryOperator.Split : QueryOperator.Empty;
        //     query = query.concat(
        //         entity.name ? 'name'
        //             + QueryOperator.Contain + entity.name
        //             + QueryOperator.Split : QueryOperator.Empty
        //     );
        //     query = query.concat(
        //         entity.acronym ? 'acronym'
        //             + QueryOperator.Contain + entity.acronym
        //             + QueryOperator.Split : QueryOperator.Empty
        //     );

        //     this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
        // }

        if (event) {
            const page = ((event.first + event.rows) / event.rows - 1).toString();
            const size = event.rows.toString();
            this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
            this.httpParams = this.httpParams.set(QueryOperator.SizeParam, size);
        }
        return this.httpParams;
    }

    getFechaServer(): Observable<any>  {
        this.spinnerService.showAll();
        const url = `${this.rutaServidor}${this.uri}serverDate`;
        return this.httpClient.post<any>(url, undefined,)
            .pipe(
              tap(response => {
                this.spinnerService.hideAll();
                return response;
              })
           );
    }

    registrarMarcacion(entity?: ClockEntry, euId?: any, event?: LazyLoadEvent) {
        const params = new HttpParams()
        .set('euId', euId)
        this.spinnerService.showAll();
        const url = `${this.rutaServidor}${this.uri}registerClockEntry`;
        return this.httpClient.post<any>(url, entity, {params},)
            .pipe(
                tap(response => {
                   //console.log(response);
                    this.spinnerService.hideAll();
                })
            );

    }

    importClockEntry(euId: number,file: File): Observable<any> {
        const url = `${this.rutaServidor}${this.uri}import/biometricTimeClock`;
        let params = new HttpParams()
        .set('euId', euId.toString())
        this.spinnerService.showAll();
      const uploadData: FormData = new FormData();
      uploadData.append('file', file, file.name);
      return this.httpClient.post(url, uploadData ,{params})
      .pipe(
        tap(response => {
            //console.log(response);
             this.spinnerService.hideAll();
         })
     );


    }

    importClockEntryAsync(euId: number,file: File,uploadType:string): Observable<any> {
        const url = `${this.rutaServidor}${this.uri}import/biometricTimeClockAsync`;
        let params = new HttpParams()
        .set('euId', euId.toString())
        .set('uploadType',uploadType)

        this.spinnerService.showAll();
      const uploadData: FormData = new FormData();
      uploadData.append('file', file, file.name);
      return this.httpClient.post(url, uploadData ,{params})
      .pipe(
        tap(response => {
            //console.log(response);
             this.spinnerService.hideAll();
         }),
                catchError(e => {
                    this.spinnerService.hideAll();

                    
                    let mensajeError = "Ocurrió un error inesperado";
                    if (e.error) {
                        
                        if (e.error.messages && e.error.messages.length > 0) {
                            mensajeError = e.error.messages[0];
                        } else if (e.error.message) {
                            mensajeError = e.error.message;
                        }
                    }

                    
                    this.notificationService.smallBoxError(mensajeError);

                    
                    return Observable.empty();
                })
     );


    }


    updateAttendanceImport(entity: BiometricTimeClockImport): Observable<BiometricTimeClockImport> {
        
        const url = `${this.rutaServidor}${this.uri}import/updateAttendanceImport`;
        this.spinnerService.showAll();
        return this.httpClient.post<BiometricTimeClockImport>(url, entity)
            .pipe(
                tap(response => {
                    // debugger;
                    // this.convertToDate(response);
                    this.spinnerService.hideAll(); 
                })
                ,
                catchError(e=>{  
                    this.spinnerService.hideAll();
                    let newEntity : BiometricTimeClockImport
                    this.notificationService.smallBoxError(e.error.messages[0]); 
                     return Observable.throw(newEntity);
                  })
            );
    }
}



// WEBPACK FOOTER //
// ./src/app/core/services/clock-entry.service.ts